import { svg } from "lit";

export function userRoundCheckIcon() {
  return svg`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.33325 14C1.3332 12.9735 1.62934 11.9689 2.18615 11.1066C2.74296 10.2443 3.53677 9.56095 4.47232 9.13865C5.40787 8.71634 6.44541 8.57297 7.46042 8.72575C8.47544 8.87854 9.4248 9.32097 10.1946 9.99997M10.6666 12.6667L11.9999 14L14.6666 11.3333M9.99992 5.33333C9.99992 7.17428 8.50753 8.66667 6.66658 8.66667C4.82564 8.66667 3.33325 7.17428 3.33325 5.33333C3.33325 3.49238 4.82564 2 6.66658 2C8.50753 2 9.99992 3.49238 9.99992 5.33333Z" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
}
